import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
const supabaseServiceRole = process.env.SUPABASE_SERVICE_ROLE_KEY;

let adminClient = null;

/**
 * Creates an admin Supabase client with service role key
 * This bypasses Row Level Security (RLS) for admin operations
 * ONLY use this for trusted server-side admin operations
 */
export const createAdminClient = () => {
  // Validate environment variables
  if (!supabaseUrl) {
    console.error('❌ NEXT_PUBLIC_SUPABASE_URL is not configured');
    throw new Error('NEXT_PUBLIC_SUPABASE_URL is not configured');
  }
  
  if (!supabaseServiceRole) {
    console.error('❌ SUPABASE_SERVICE_ROLE_KEY is not configured');
    console.error('⚠️ Add SUPABASE_SERVICE_ROLE_KEY to your .env file');
    console.error('🔑 Get it from: Supabase Dashboard > Settings > API > service_role key');
    throw new Error('SUPABASE_SERVICE_ROLE_KEY is not configured. Admin operations require service role key.');
  }

  // Return existing client if already created (singleton pattern)
  if (adminClient) {
    return adminClient;
  }

  // Create admin client with service role key (bypasses RLS)
  adminClient = createClient(supabaseUrl, supabaseServiceRole, {
    auth: {
      autoRefreshToken: false,
      persistSession: false
    },
    // CRITICAL: Ensure service_role context is properly set
    db: {
      schema: 'public'
    },
    global: {
      headers: {
        'X-Client-Info': 'supabase-admin-client'
      }
    }
  });

  console.log('✅ Supabase admin client initialized with service role');
  console.log('🔓 RLS will be bypassed for this client');
  return adminClient;
};

export default createAdminClient;